<template>
  <div id="bookmarked-products" style="margin-bottom: 100px">
    <div class="card mb-2" v-for="(value, index) in bookmarks" :key="index">
      <div class="card-body">
        <router-link
          :to="'/products/' + value.product.uuid"
          class="product-link"
        >
          <h5 class="card-title uppercase">{{ value.product.name }}</h5>
        </router-link>
        <h6 class="card-subtitle mb-2 text-muted capitalize">
          <router-link
            :to="'/suppliers/' + value.product.supplier.uuid"
            class="no-text-decoration"
            >{{ value.product.supplier.name }}</router-link
          >
        </h6>
        <div class="card-text" v-html="value.product.description"></div>
        <p>Bookmark Date: {{ value.created_at }}</p>
        <span class="card-link">
          <i class="fas fa-map-marker-alt" />
          {{ value.product.community }}
        </span>
        <span class="card-link">
          <i class="fa fa-eye" />
          {{ value.product.threshhold }}
        </span>
        <span class="card-link">
          <i class="fas fa-truck" />
          {{ value.product.quantity }}
        </span>
        <span
          class="card-link"
          data-toggle="tooltip"
          :title="`Will be ready in ${value.product.ready_time || 0} days`"
        >
          <i class="fas fa-calendar-check" />
          {{ value.product.ready_time || 0 }} days
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      bookmarks: []
    }
  },
  mounted() {
    this.bookmarks = this.data
  }
}
</script>
<style lang="scss" scoped>
.product-link {
  &:hover {
    text-decoration: none;
  }
}
</style>